(() => {
  const WEEKLY_MATCH = 'Weekly Lease';

  function getProductInfo() {
    return document.querySelector('product-info[data-section]');
  }

  function getSectionId() {
    return getProductInfo()?.getAttribute('data-section') || null;
  }

  function getProductJson(sectionId) {
    const el = document.getElementById(`FWC-Product-${sectionId}`);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  }

  function getSelectedVariantId(sectionId) {
    const root = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : document;
    const input = root?.querySelector('form[action^="/cart/add"] input[name="id"]');
    return input?.value ? String(input.value) : null;
  }

  function isWeeklyVariant(productJson, variantId) {
    const v = productJson?.variants?.find(x => String(x.id) === String(variantId));
    if (!v) return false;

    const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(String);
    if (opts.some(o => o.includes(WEEKLY_MATCH))) return true;

    return String(v.title || '').includes(WEEKLY_MATCH);
  }

  function toggleSuffix(show, sectionId) {
    const scope = sectionId ? document.getElementById(`price-${sectionId}`) : document;
    (scope || document).querySelectorAll('.fwc-per-week-suffix').forEach(el => {
      el.hidden = !show;
    });
  }

  function update() {
    const sectionId = getSectionId();
    if (!sectionId) {
      toggleSuffix(false, null);
      return;
    }

    const productJson = getProductJson(sectionId);
    const variantId = getSelectedVariantId(sectionId);

    if (!productJson || !variantId) {
      toggleSuffix(false, sectionId);
      return;
    }

    toggleSuffix(isWeeklyVariant(productJson, variantId), sectionId);
  }

  function init() {
    update();
    setTimeout(update, 200);
    setTimeout(update, 800);

    document.addEventListener('change', update, true);
    document.addEventListener('input', update, true);
    document.addEventListener('click', update, true);

    const sectionId = getSectionId();
    const root = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : document;
    const idInput = root?.querySelector('form[action^="/cart/add"] input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', update);
      new MutationObserver(update).observe(idInput, { attributes: true });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();